import { Card, Col, Row } from "antd";
import React from "react";
import leadIcon from "../../../../assets/images/icon/Quickly Add Leads.svg";
import BadgeIcon from "../../../../assets/images/icon/Badge Scanner.svg";
import offlineIcon from "../../../../assets/images/icon/Offline Mode.svg";
import ScannerIcon from "../../../../assets/images/icon/Card Scanner with OCR.svg";
import integrationIcon from "../../../../assets/images/icon/WhatsApp-Email Integration.svg";
import summaryIcon from "../../../../assets/images/icon/AI-based Summary.svg";
import featureImg from "../../../../assets/images/featureImg.png";
import { ReactComponent as StarIcon } from "../../../../assets/images/icon/Star.svg";

import Slider from "react-slick";

const Features: React.FC<any> = () => {
    const settings = {
        slidesToShow: 4,
        dots: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 8000,
        pauseOnHover: false,
        cssEase: 'linear',
        slidesToScroll: 1,
        focusOnSelect: true,
        arrows: false,
        centerMode: false,
        vertical: false,
        infinite: true,
        adaptiveHeight: false,
        lazyIndicator: "/arquivos/ajax-loader.gif",

        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };
    return (
        <>
            <section className="section featureSection" id="featurepage">
                <div className="featureSlider">
                    <Slider {...settings}>
                        <div className="featureWrap">
                            <span className="outlineHeading">feature</span>
                            <StarIcon className="starIcon" />
                        </div>
                        <div className="featureWrap">
                            <span className="heading">feature</span>
                            <StarIcon className="starIcon" />
                        </div>
                        <div className="featureWrap">
                            <span className="outlineHeading">feature</span>
                            <StarIcon className="starIcon" />
                        </div>
                        <div className="featureWrap">
                            <span className="heading">feature</span>
                            <StarIcon className="starIcon" />
                        </div>

                    </Slider>
                </div>
                <div className="containerCard container">
                    <Row>
                        <Col span={9}>
                            <div className="leftCardSection">
                                <div className="cardRight">
                                    <Card>
                                        <div className="cardWrapp">
                                            <div className="cardHead">
                                                <div className="cardIcon">
                                                    <img src={leadIcon} alt="Setting Icon" />
                                                </div>
                                                <h3>Quickly Add Leads</h3>
                                            </div>
                                            <p className="cardPera">
                                                Meet prospects and visitors without worrying about getting their data as kapturely add all the leads
                                                quickly for you!
                                            </p>
                                        </div>
                                    </Card>
                                </div>

                                <Card>
                                    <div className="cardWrapp">
                                        <div className="cardHead">
                                            <div className="cardIcon">
                                                <img src={BadgeIcon} alt="Setting Icon" />
                                            </div>
                                            <h3>Badge Scanner</h3>
                                        </div>
                                        <p className="cardPera">
                                            People participating in major events get badges for identity and kapturely can scan it easily for
                                            capturing data.
                                        </p>
                                    </div>
                                </Card>
                                <div className="cardRight">
                                    <Card>
                                        <div className="cardWrapp">
                                            <div className="cardHead">
                                                <div className="cardIcon">
                                                    <img src={offlineIcon} alt="Setting Icon" />
                                                </div>
                                                <h3>Offline Mode</h3>
                                            </div>
                                            <p className="cardPera">
                                                Your kapturely app works in offline mode as well so that you can sync the information right away as
                                                the Internet is available!
                                            </p>
                                        </div>
                                    </Card>
                                </div>

                            </div>
                        </Col>
                        <Col span={6} className="featureCol">
                            <img src={featureImg} alt="feature img" />

                        </Col>
                        <Col span={9}>

                            <div className="rightCardSection">
                                <Card>
                                    <div className="cardWrapp">
                                        <div className="cardHead">
                                            <div className="cardIcon">
                                                <img src={ScannerIcon} alt="Setting Icon" />
                                            </div>
                                            <h3>Card Scanner with OCR</h3>
                                        </div>
                                        <p className="cardPera">
                                            Built-in OCR in a card scanner enables you to get the necessary data from visiting cards of your
                                            visitors right away.
                                        </p>
                                    </div>
                                </Card>
                                <div className="cardRight">
                                    <Card>
                                        <div className="cardWrapp">
                                            <div className="cardHead">
                                                <div className="cardIcon">
                                                    <img src={integrationIcon} alt="Setting Icon" />
                                                </div>
                                                <h3>WhatsApp/Email Integration</h3>
                                            </div>
                                            <p className="cardPera">
                                                Stay in touch with prospects after the event as kapturely sends a WhatsApp message and an email
                                                with customized details!
                                            </p>
                                        </div>
                                    </Card>
                                </div>
                                <Card>
                                    <div className="cardWrapp">
                                        <div className="cardHead">
                                            <div className="cardIcon">
                                                <img src={summaryIcon} alt="Setting Icon" />
                                            </div>
                                            <h3>AI-based Summary</h3>
                                        </div>
                                        <p className="cardPera">
                                            Get AI-powered summary of every prospect in the app to analyze and get the necessary action to
                                            convert the lead.
                                        </p>
                                    </div>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default Features;
